import React, { useEffect, useState, useRef } from 'react';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from 'lucide-react';
import AnimateOnScroll from './ui/AnimateOnScroll';
import MobileFixWrapper from './MobileFixWrapper';

const Hero = () => {
  const [isSticky, setIsSticky] = useState(false);
  const heroRef = useRef(null);
  const spacerRef = useRef(null);

  useEffect(() => {
    const hero = heroRef.current;
    const spacer = spacerRef.current;
    
    if (!hero || !spacer) return;

    const heroHeight = hero.offsetHeight;
    spacer.style.height = `${heroHeight}px`;

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
        hero.classList.add('sticky-hero');
      } else {
        setIsSticky(false);
        hero.classList.remove('sticky-hero');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <MobileFixWrapper>
      <>
        {/* Spacer div to prevent layout shift when hero becomes fixed */}
        <div ref={spacerRef} className={isSticky ? 'block' : 'hidden'}></div>
        
        <section 
          ref={heroRef}
          className={`w-full max-w-[100vw] ${isSticky ? 'fixed top-0 left-0 right-0 z-50 py-4 bg-white shadow-md' : 'py-20 md:py-32'}`}
        >
          <div 
            className={`absolute inset-0 w-full h-full bg-cover bg-center ${isSticky ? 'hidden' : 'block'}`}
            style={{ 
              backgroundImage: 'url("/lovable-uploads/204d2a72-8e7d-4b80-98b9-7c1fe99f170f.png")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: 0.5
            }}
          ></div>
          
          <div 
            className={`absolute inset-0 w-full h-full ${isSticky ? 'hidden' : 'block'}`}
            style={{ 
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 100%)',
            }}
          ></div>
          
          <div className="container mx-auto px-4 md:px-8 relative z-10 box-border max-w-full overflow-hidden">
            <div className="flex flex-col items-center text-center">
              <AnimateOnScroll animation="animate-slide-in-left" delay={100}>
                {isSticky ? (
                  <div className="flex justify-between items-center w-full">
                    <div className="inline-block"> {/* הוספתי עטיפה זו כדי לשמור על גודל הכפתור */}
                      <Button 
                        className="bg-tech-blue hover:bg-tech-blue/90 text-white font-medium px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-2"
                        size="sm"
                        asChild
                      >
                        <a href="https://cal.com/shlomit-zabner" target="_blank" rel="noopener noreferrer" className="inline-flex whitespace-nowrap text-xs"> {/* הקטנת גודל טקסט */}
                          לקביעת שיחה ראשונית
                          <ArrowLeft className="w-3 h-3" />
                        </a>
                      </Button>
                    </div>
                    <h2 className="text-lg font-bold text-tech-darkGray">חוסכים זמן ומתייעלים</h2>
                  </div>
                ) : (
                  <div className="max-w-full mx-auto box-border">
                    <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6 text-white">
                      לעבוד יעיל -   
                      <span className="block text-tech-white mt-2">פתרונות דיגיטליים מותאמים אישית</span>
                      <span className="block text-tech-white mt-2">כדי לפנות לך זמן לדברים החשובים באמת</span>
                    </h1>
                                      <div className="inline-block"> {/* הוספתי עטיפה זו כדי לשמור על גודל הכפתור */}
                      <Button 
                        className="bg-gradient-to-r from-tech-blue to-indigo-600 hover:from-tech-blue/90 hover:to-indigo-600/90 text-white font-medium px-6 py-4 md:px-8 md:py-6 rounded-xl shadow-md shadow-blue-200/50 transition-all duration-200 flex items-center gap-2"
                        size="lg"
                        asChild
                      >
                        <a href="https://cal.com/shlomit-zabner" target="_blank" rel="noopener noreferrer" className="inline-flex whitespace-nowrap"> {/* הוספתי מחלקות אלו */}
                         לקביעת שיחה ראשונית
                          <ArrowLeft className="w-5 h-5 md:w-6 md:h-6" />
                        </a>
                      </Button>
                    </div>
                  </div>
                )}
              </AnimateOnScroll>
            </div>
          </div>
        </section>
        
        {/* Add this to your global CSS or style tag */}
        <style dangerouslySetInnerHTML={{
          __html: `
          .sticky-hero {
            transition: all 0.3s ease;
          }
          @media (max-width: 768px) {
            h1 {
              font-size: 1.75rem;
              line-height: 1.3;
            }
            p {
              font-size: 0.95rem;
            }
            .py-20 {
              padding-top: 3rem;
              padding-bottom: 3rem;
            }
          }
        `}} />
      </>
    </MobileFixWrapper>
  );
};

export default Hero;